"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonFieldsCms = void 0;
var CommonFieldsCms = /** @class */ (function () {
    function CommonFieldsCms() {
        this.requiredFieldInputBox = 'Required field';
        this.invalidCharInputBox = 'Invalid character';
        this.invalidCharBankNameInputBox = 'Enter a valid name. Only these special characters are allowed: dash (-), apostrophe (\'), ampersand (&), period (.), dollar sign ($), and the pound sign (#).';
        this.iconAccessibilityAriaLabel = 'Icon';
        this.errorAccessibilityAriaLabel = 'Error';
        this.availableAccessibilityAriaLabel = 'Available';
        this.inProgressPanelLabel = 'This is in progress';
        this.preownedLabel = '[Certified Pre-owned]';
    }
    return CommonFieldsCms;
}());
exports.CommonFieldsCms = CommonFieldsCms;
//# sourceMappingURL=CommonFields.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/cms/CommonFields.cms.js
// module id = 932
// module chunks = 8